import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { AccountMemberActions } from '@page/account-settings/account-members/account-member-actions/account-member-actions';

import { InviteStatusEnum } from '@enum/invite-status.enum';
import { RoleEnum } from '@enum/role.enum';
import { RoleNames } from '@util/constants/role-names';

import { TagStatus } from './account-members.style';

export const accountMembersOptions: ColumnsType<any> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    render: (role: RoleEnum) => RoleNames[role],
  },
  {
    title: 'Invited',
    key: 'createdAt',
    render: (member) => (member?.role === RoleEnum.Owner ? null : dayjs(member.createdAt).format('DD/MM/YYYY HH:mm')),
  },
  {
    title: 'Status',
    key: 'status',
    render: (member) => {
      if (member.role === RoleEnum.Owner) return null;
      if (member.isSuspended) return <TagStatus status={InviteStatusEnum.Suspended}>Suspended</TagStatus>;
      return <TagStatus status={member.status}>{member.status}</TagStatus>;
    },
  },
  {
    key: 'action',
    width: 64,
    render: (member) => {
      if (member.role === RoleEnum.Owner) return null;
      return <AccountMemberActions member={member} />;
    },
  },
];
